import React from "react";
// import data from "./data.json";
import BackgroundSlider from 'react-background-slider';
import './index.css';

import image1 from './assets/image2.jpg';
import image2 from "./assets/slide2.jpg";
import image3 from "./assets/slide3.jpg";
import image4 from "./assets/slide4.jpg"
import image5 from './assets/slide5.jpg';
import {ReactComponent as ReactLogo} from './logo.svg'
import {ReactComponent as Chevron} from './assets/downChevron.svg'

var Scroll = require('react-scroll');
var scroll = Scroll.animateScroll;

const Cover = () => {

  return (
    <div className="coverOverlay" id="landingPageCover">
        <BackgroundSlider
            images={[image1, image2, image3, image4, image5]}
            duration={3} transition={0} 
            />
        <div className="topBar">
            <ReactLogo className="logo" onClick={(e) => {e.preventDefault(); window.location.href='https://michigandaily.com/';}}/>
            <button class="donateButton" onClick={(e) => {e.preventDefault(); window.location.href='https://leadersandbest.umich.edu/find/#!/give/basket/fund/314932?Amount=20';}}>Donate</button>
        </div>
        <div className="titleBox">
            <h1>FACEOFF <br/> EDITION</h1>
            <p>SPORTS</p>
            <button class="donateButton2" onClick={(e) => {e.preventDefault(); window.location.href='https://leadersandbest.umich.edu/find/#!/give/basket/fund/314932?Amount=20';}}>Donate</button>
        </div>
        <Chevron className="chevron" onClick={(e) => {e.preventDefault(); scroll.scrollTo(window.innerHeight);}}/>
    </div>
  );
};

export default Cover;
